export const privacyPolicy = () => {
  const privacyOpenBtn = document.querySelector(".js-privacy-open");
  const privacyModal = document.querySelector(".js-privacy-modal");
  const privacymodalclosebtn = document.querySelector(".js-privacy-modal-close");

  if (!privacyOpenBtn) return;

  privacyOpenBtn.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    // ここにポリシーを開く処理を追加

    privacyModal.classList.add("is-open");
    document.body.style.overflow = "hidden";
  });

  privacymodalclosebtn.addEventListener("click", (e) => {
    privacyModal.classList.remove("is-open");
    document.body.style.overflow = "";
  });
};
